/*
Usage Notes: 

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  {% assign skioSellingPlanGroups = product.selling_plan_groups | where: 'app_id', 'SKIO' %}
  {% if skioSellingPlanGroups.size > 0 %}
    <skio-plan-picker 
      product='{{ product | json | escape }}'
      selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
      formId='{{ product_form_id }}'
      externalPriceSelector='#price-inner-button .money'
      externalPriceSelectorWithCurrency='[data-product-price-list] .money'
      currency='USD'
      >
    </skio-plan-picker>
    <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>
    {% render 'skio-details' %}
  {% endif %}

  Note: formId not required if element is inside of a form already

  Example variantChanged event dispatch:
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

const skioStyles = css`
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 19px;
    padding: 0;
    border: 0;
  }
  .skio-onetime-second {
    order: 2;
  }

  .final {
    order: 3;
  }
  
  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    /* box-shadow: 0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.07); */
    border-radius: 9px;
    border-width: 1px;
    border-color: #B6B6AE;
    border-style: solid; 
    transition: background-color 0.2s ease;

    color: #000;
    font-size: 13px;
  }
  .skio-group-container--selected {
    background: rgb(229, 228, 217);
  }

  [skio-group-onetime], [skio-group-subscription] {
    position: relative;
  }

  [skio-group-onetime]:after {
    content: "BEST SELLER";
    position: absolute;
    top: -13px;
    right: 10px;
    padding: 4px 10px;
    border-radius: 4px;
    color: rgb(0, 0, 0);
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: rgb(245, 244, 234);
    /* font-weight: 700; */
    font-family: "Neue Haas Grotesk Text Pro 65", sans-serif;
    font-size: 10px;
    letter-spacing: 0.2px;
  }

  [skio-group-subscription]:after {
    content: "BEST VALUE";
    position: absolute;
    top: -13px;
    right: 10px;
    padding: 4px 10px;
    border-radius: 4px;
    color: #fff;
    background-color: #000;
    /* font-weight: 700; */
    font-family: "Neue Haas Grotesk Text Pro 65", sans-serif;
    font-size: 10px;
    letter-spacing: 0.2px;
  }
  
  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 10px;
    overflow: hidden;
  }
  
  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;

    flex-wrap: nowrap;
  }
  
  .skio-radio__container {
    display: flex;
    margin-right: 10px;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price {
    margin-left: auto;
    font-weight: 500;
    font-size: 14px;

    font-family: "Neue Haas Grotesk Text Pro 65", sans-serif;
    margin-right: 10px;

    white-space: nowrap;
  }

  .skio-price del {
    color: #898982;
    margin-left: 5px; 
    font-family: "Neue Haas Grotesk Text", sans-serif;
  }
  
  .skio-group-content {
    width: auto;
    margin-left: 30px;
    /* transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1),
                opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    max-height: 38px;
    opacity: 1; */

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;

    /* align-items: center; */

    font-family: Untitled-Sans-Regular, sans-serif;
    font-size: 13px;

    padding-top: 10px;
    padding-bottom: 10px;

  }

  .skio-group-content div {
    display: flex;
    align-items: center;
    justify-content: center;

    letter-spacing: -0.2px !important;

    white-space: nowrap;
  }

  .skio-group-content div span {
    font-size: 10px;
    margin-left: 4px;
  }

  .skio-group-content div svg {
    margin-right: 11px;
  }

  .skio-group-content div svg.dot {
    margin-left: 5px;
    margin-right: 17px;
  }
  
  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    /* max-height: 0;
    opacity: 0; */
    pointer-events: none;
  }
  
  .skio-group-title {
    /* min-width: max-content; */
    font-weight: 400;
    font-size: 15px;

    font-family: "Neue Haas Grotesk Text Pro 65", sans-serif;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .skio-group-title .title {
    margin-right: 5px;
  }

  .skio-group-title span.bundle {
    font-size: 14px;
    font-family: "Neue Haas Grotesk Text Pro", sans-serif;
    font-weight: 400 !important;
  }

  @media (max-width: 991px) {
    .skio-group-title {
      text-align: left;
    }
    .skio-save [skio-discount] {
      display: block;
    }
    .skio-group-title span.bundle {
      display: block;
      margin-left: 0px;
    }
  }
  
  .skio-save {
    /* color: #0fa573;
    border: 1px #0fa573 solid; 
    padding: 0px 8px;
    border-radius: 20px; */
  }

  .skio-save [skio-discount] {
    background-color: #E7FE7D;
    padding: 0px 5px;
    font-size: 14px;
  }
  
  .skio-frequency {
    display: flex;
    align-items: center;
    /* gap: 5px;
    padding: 8px 30px 8px 10px; */
    /* margin-top: 5px;
    border-radius: 5px; */

    background-color: rgba(0, 0, 0, 0.1);
    padding: 7px 24px 7px 19px;
    font-size: 1.05em;
    text-transform: capitalize;

    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    /* background-image: url("https://cdn.shopify.com/s/files/1/0455/3418/3575/t/21/assets/ico-select.svg?v=115630813262522069291686954392"); */
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 11px auto;

/* 
    width: 100%; */
    border: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat; */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    border-radius: 20px;
    margin-left: 8px;
    margin-right: 8px;
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }

  button.add-to-cart {
    width: 100%;
    border: none;
    border-radius: 9px;
    /* margin: 15px 0px 0px; */
    padding: 15px 0px;
    font-size: 16px;
    background: #000;
    color: #fff;
    font-family: "Untitled-Sans-Medium", sans-serif;

    cursor: pointer;
  }

  .bottom-copy {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    gap: 4px;
    position: relative;
    flex-shrink: 0;
    box-sizing: border-box;
    margin-top: 0px;
    line-height: normal;
    height: auto;
    text-align: left;
    color: rgb(0, 0, 0);
    
    letter-spacing: 0.1px;
    font-size: 12px;
    margin-bottom: 20px;

    margin-top: 5px;

    font-family: "Neue Haas Grotesk Text Pro", sans-serif;
    font-weight: 400 !important;
  }

  .bottom-copy span {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;

    white-space: nowrap;
    
  }

  @media (max-width: 1150px) {
    .bottom-copy span {
      font-size: 10px;
    }
  }

  @media (max-width: 992px) {
    .bottom-copy span {
      font-size: 12px;
    }
  }

  @media (max-width: 450px) {
    .bottom-copy span {
      font-size: 10px;
    }
  }

  @media (max-width: 370px) {
    .bottom-copy span {
      font-size: 9px;
    }
  }

  .clearpay {
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: center;
    font-family: "Neue Haas Grotesk Text Pro", sans-serif;
    color: #000;
  }

  .clearpay span:first-child {
    margin-right: 4px;
  }

  .clearpay svg {
    margin-right: 4px;
  }

`;

let product = window.mainProduct;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },            //required
    productHandle: { type: String },      //optional (unless product isn't passed, then required)
    key: { type: String },                //optional, defaults to product.id; identifier for this instance of the Skio plan picker
    
    formId: { type: String },             //optional; if passed, used to connect input fields to form
    needsFormId: { type: Boolean },       //optional, defaults to false; if true, element needs to be passed a formId, else it searches for a form

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    discountFormat: { type: String },     //optional, defaults to percent; can also pass "fixed"
    
    currency: { type: String },           //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String },           //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {},                   //placeholder for object

    externalPriceSelector: { type: String },      //optional, used to update the external price

    externalPriceSelectorWithCurrency: { type: String },      //optional, used to update the external price
  
    selectedVariant: { type: Object },    //placeholder for data
    skioSellingPlanGroups: {},            //placeholder for data
    availableSellingPlanGroups: {},       //placeholder for data
    selectedSellingPlanGroup: {},         //placeholder for data
    selectedSellingPlan: {},              //placeholder for data

    defaultFrequency: {},                 //placeholder for data
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = product;
    this.selectedVariant = null;

    this.productHandle = null;

    this.purchaseOption = 'onetime';

    this.key = null;
    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.externalPriceSelector = '[skio-external-price]';

    this.externalPriceSelectorWithCurrency = '[skio-external-price-with-currency]';

    this.currency = window.currency;
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
    });

    this.defaultFrequency = null;

  }

  connectedCallback() {
    super.connectedCallback();

    if (this.product == null) {
      this.product = window.mainProduct;
      this.requestUpdate();
    } else {
      this.selectedVariant = this.product.selected_or_first_available_variant;
      this.requestUpdate();
    }

    if (this.startSubscription == true) {
      this.purchaseOption = 'subscription';
    }

    if(!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    if (this.needsFormId && this.formId == null) {
      let forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length > 0) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute('skio-key')) {
            if (el.getAttribute('skio-key') == this.key) form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }
    let skio = this;
    document.addEventListener("variantChanged", function(e) {
      //update variant id
      let variantId = e.detail.variantId;
      let variant = skio.product.variants.find(x => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

  }

  render() {
    if(!this.product || !this.selectedVariant || this.skioSellingPlanGroups.length == 0) return;
    
    return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${ this.key }">
        <input ${ this.formId !== null ? html`form="${ this.formId }"` : '' } name="selling_plan" type="hidden" value="${ this.selectedSellingPlan !== null ? this.selectedSellingPlan?.id : ''}" />
        <input ${ this.formId !== null ? html`form="${ this.formId }"` : '' } name="properties[Discount]" type="hidden" value="${ this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : '' }" 
          ?disabled="${ this.selectedSellingPlan == null ? true : false }" />
        
        <div class="skio-group-container ${ this.product.requires_selling_plan == false ? 'skio-group-container--available' : '' } ${ this.selectedSellingPlanGroup == null ? 'skio-group-container--selected' : '' } ${ this.subscriptionFirst ? 'skio-onetime-second' : ''}" skio-group-onetime skio-group-container 
          @click=${() => this.selectSellingPlanGroup(null) } >
        
          <input id="skio-one-time-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }" type="radio" value="" 
            skio-one-time ?checked=${ this.startSubscription == false && this.product.requires_selling_plan == false ? true : false }>
          <label class="skio-group-label" for="skio-one-time-${ this.key }">
            <div class="skio-group-topline">
              <div class="skio-radio__container">
                <svg width="24" height="24" viewBox="1 1 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
                  <circle class="skio-radio" cx="12" cy="12" r="6" fill="currentColor"></circle>
                </svg>
              </div>
              <div class="skio-group-title">
                <span class="title">One-time purchase</span>
                
                ${ this.selectedVariant.compare_at_price > this.selectedVariant.price ? html`
                  <span class="bundle">(Bundle & save ${ this.moneyFormatter.format((this.selectedVariant.compare_at_price - this.selectedVariant.price) / 100).replaceAll('.00', '') })</span>
                ` : html`` }
              </div>
              <div class="skio-price">
                <span skio-onetime-price>
                  ${ this.moneyFormatter.format(this.selectedVariant.price / 100).replaceAll('.00', '') }
                  ${ this.selectedVariant.compare_at_price > this.selectedVariant.price ? html`
                    <del>${ this.moneyFormatter.format(this.selectedVariant.compare_at_price / 100).replaceAll('.00', '') }</del>
                  ` : html``}
                </span>
              </div>
            </div>
          </label>
        </div>
        ${ this.availableSellingPlanGroups ? this.availableSellingPlanGroups.map((group, index) => 
          html`
            <div class="skio-group-container skio-group-container--available ${ this.selectedSellingPlanGroup == group ? 'skio-group-container--selected' : '' }" skio-group-container skio-group-subscription
              @click=${() => this.selectSellingPlanGroup(group) }>
              <input id="skio-selling-plan-group-${ index }-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }"
                type="radio" value="${ group.id }" skio-selling-plan-group="${ group.id }" ?checked=${ this.selectedSellingPlanGroup == group ? true : false } >
              <label class="skio-group-label" for="skio-selling-plan-group-${ index }-${ this.key }">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                    <svg width="24" height="24" viewBox="1 1 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
                      <circle class="skio-radio" cx="12" cy="12" r="6" fill="currentColor"></circle>
                    </svg>
                  </div>
                  <div class="skio-group-title">
                    ${ group.name == 'Subscription' ? 'Subscribe & save ' : group.name }
                    ${ this.discount(group.selected_selling_plan).percent !== '0%' ? html`
                      <span class="skio-save">
                        <span skio-discount>
                          ${ this.discountFormat == 'percent' ? this.discount(group.selected_selling_plan).percent : this.discount(group.selected_selling_plan).amount } off ${ this.selectedVariant.compare_at_price > this.selectedVariant.price && this.product.handle != 'skin-essentials-duo-pre-sale' ? html`+ free shipping` : html`` }
                        </span>
                      </span>
                    ` : html`` }
                  </div>
                  <div class="skio-price">
                    <span skio-subscription-price>
                      ${ this.price(group.selected_selling_plan).replaceAll('.00', '') }
                      <del>${ this.moneyFormatter.format(this.selectedVariant.price / 100).replaceAll('.00', '') }</del>
                    </span>
                  </div>
                </div>

                <div class="skio-group-content">
                  ${ this.selectedVariant.compare_at_price > this.selectedVariant.price ? html`
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path d="M5.7721 2.56524L6.69027 4.12494H4.75782C4.46016 4.15658 4.1625 4.06049 3.93985 3.8601C3.71661 3.6603 3.58947 3.37436 3.58947 3.07494C3.58947 2.77553 3.71662 2.4896 3.93985 2.28978C4.16251 2.0894 4.46017 1.99329 4.75782 2.02494H4.81524C5.20724 2.02201 5.57172 2.22774 5.7721 2.56524ZM2.43925 3.06915C2.44043 3.43653 2.53008 3.79865 2.7 4.12502H1.59317C1.12734 4.12502 0.75 4.50236 0.75 4.96818V6.65748V6.6569C0.75 7.12272 1.12734 7.50006 1.59317 7.50006H13.4069C13.8727 7.50006 14.25 7.12272 14.25 6.6569V4.9682C14.25 4.50237 13.8727 4.12503 13.4069 4.12503H12.3C12.6674 3.40725 12.6352 2.55003 12.2151 1.86153C11.7955 1.17306 11.0485 0.752356 10.2423 0.750001H10.2001C9.35809 0.750001 8.57873 1.19472 8.15108 1.92012L7.50011 3L6.86437 1.92012C6.43663 1.19474 5.65733 0.749416 4.81537 0.750001H4.75794C4.14329 0.750001 3.55326 0.994336 3.11844 1.4291C2.68368 1.86386 2.43925 2.45385 2.43925 3.06915ZM11.2981 3.06915C11.2981 3.34923 11.1868 3.61758 10.9887 3.81564C10.7907 4.01369 10.5223 4.12502 10.2422 4.12502H8.30979L9.22795 2.56532C9.42892 2.21961 9.80041 2.00985 10.2 2.01629H10.2569C10.8334 2.02449 11.2963 2.4926 11.2981 3.06915ZM1.59325 8.34315V12.9839C1.59325 13.6835 2.15985 14.2501 2.85888 14.2501H6.65688V8.34321L1.59325 8.34315ZM8.34325 14.25H12.1413C12.8403 14.25 13.4069 13.6834 13.4069 12.9838V8.34309H8.34318L8.34325 14.25Z" fill="black"/>
                      </svg>
                      Free wash bag & face towel
                      <span>(new customers)</span>
                    </div>
                  ` : html`` }
                  <div>
                    <svg class="dot" xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                      <path d="M3.98507 2.272C3.98507 2.76267 3.81973 3.17333 3.48907 3.504C3.16907 3.83467 2.7584 4 2.25707 4C1.75573 4 1.33973 3.83467 1.00907 3.504C0.689066 3.17333 0.529066 2.76267 0.529066 2.272C0.529066 1.77067 0.689066 1.36 1.00907 1.04C1.33973 0.709333 1.75573 0.544 2.25707 0.544C2.7584 0.544 3.16907 0.709333 3.48907 1.04C3.81973 1.36 3.98507 1.77067 3.98507 2.272Z" fill="#0A0A0A"/>
                    </svg>
                    Delivers ${group.selected_selling_plan.name.toLowerCase()}
                  </div>
                  <div>
                  <svg class="dot" xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                      <path d="M3.98507 2.272C3.98507 2.76267 3.81973 3.17333 3.48907 3.504C3.16907 3.83467 2.7584 4 2.25707 4C1.75573 4 1.33973 3.83467 1.00907 3.504C0.689066 3.17333 0.529066 2.76267 0.529066 2.272C0.529066 1.77067 0.689066 1.36 1.00907 1.04C1.33973 0.709333 1.75573 0.544 2.25707 0.544C2.7584 0.544 3.16907 0.709333 3.48907 1.04C3.81973 1.36 3.98507 1.77067 3.98507 2.272Z" fill="#0A0A0A"/>
                    </svg>
                    Skip or cancel anytime with no fees
                  </div>
                </div>

                ${ group.selling_plans.length > 1 ? html`
                  <div class="skio-group-content">
                    <div>
                      Deliver Every
                      <select skio-selling-plans="${ group.id }" class="skio-frequency"
                        @change=${ (e) => this.selectSellingPlan(e.target, group) }>
                        ${ group ? group.selling_plans.map((selling_plan) => 
                          html`
                          <option value="${ selling_plan.id }" ?selected=${group.selected_selling_plan == selling_plan }>
                          ${ selling_plan.name.toLowerCase().replace('every ', '') }
                          </option>
                          `
                        ): ''}
                      </select>
                    </div>
                    <!-- <span style="color: rgba(0,0,0,0.6)">(Cancel Anytime)</span> -->
                  </div>
                ` : html`` }
                

              </label>
            </div>
          `
        ): ''}

        <div class="final">
          <div class="clearpay">
            <span>Pay in four interest-free instalments with</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="22" viewBox="0 0 64 22" fill="none">
              <path d="M53.1205 21.759H10.8795C4.87047 21.759 0 16.8885 0 10.8795C0 4.87047 4.87047 0 10.8795 0H53.1205C59.1295 0 64 4.87047 64 10.8795C64.0039 16.8846 59.1295 21.759 53.1205 21.759Z" fill="#B2FCE4"/>
              <path d="M45.8014 8.54291L42.5952 15.1568H41.2669L42.4648 12.686L40.583 8.54291H41.9469L43.1566 11.3181L44.477 8.54291H45.8014Z" fill="black"/>
              <path d="M33.6068 10.8915C33.6068 10.1325 33.0335 9.54741 32.3299 9.54741C31.6262 9.54741 31.0529 10.1127 31.0529 10.8915C31.0529 11.6624 31.6262 12.2357 32.3299 12.2357C33.0335 12.2357 33.6068 11.6506 33.6068 10.8915ZM29.8867 15.1571V8.54327H31.0411V9.15208C31.389 8.72117 31.9069 8.4563 32.5236 8.4563C33.7926 8.4563 34.7888 9.49997 34.7888 10.8797C34.7888 12.2594 33.7728 13.311 32.4959 13.311C31.9029 13.311 31.4166 13.0777 31.0767 12.6824V15.1532H29.8867V15.1571Z" fill="black"/>
              <path d="M38.9547 10.8916C38.9547 10.1009 38.3814 9.54749 37.6778 9.54749C36.9741 9.54749 36.4008 10.1128 36.4008 10.8916C36.4008 11.6625 36.9741 12.2357 37.6778 12.2357C38.3814 12.2357 38.9547 11.6783 38.9547 10.8916ZM38.9626 13.2399V12.6311C38.6147 13.0541 38.0968 13.315 37.4801 13.315C36.1913 13.315 35.2148 12.2832 35.2148 10.8916C35.2148 9.51191 36.2308 8.46033 37.5078 8.46033C38.1087 8.46033 38.6147 8.7252 38.9626 9.13634V8.54335H40.1169V13.2399H38.9626Z" fill="black"/>
              <path d="M27.8019 9.00185C27.8019 9.00185 28.0944 8.4563 28.8179 8.4563C29.1262 8.4563 29.3239 8.56304 29.3239 8.56304V9.76089C29.3239 9.76089 28.889 9.49206 28.4897 9.54741C28.0905 9.60276 27.8375 9.96646 27.8375 10.4567V13.2398H26.6436V8.54327H27.7979V9.00185H27.8019Z" fill="black"/>
              <path d="M54.768 8.27817L53.4002 7.49542L52.0126 6.7008C51.0954 6.17501 49.949 6.83522 49.949 7.8947V8.0726C49.949 8.17143 50.0004 8.26236 50.0873 8.3098L50.7317 8.67745C50.9096 8.78024 51.131 8.64978 51.131 8.44421V8.02121C51.131 7.81168 51.3563 7.68122 51.5382 7.78401L52.8033 8.51142L54.0644 9.23487C54.2462 9.33766 54.2462 9.60253 54.0644 9.70531L52.8033 10.4288L51.5382 11.1562C51.3563 11.259 51.131 11.1285 51.131 10.919V10.7095C51.131 9.64997 49.9846 8.98581 49.0674 9.51555L47.6798 10.3102L46.3119 11.0929C45.3908 11.6227 45.3908 12.9549 46.3119 13.4847L47.6798 14.2674L49.0674 15.062C49.9846 15.5878 51.131 14.9276 51.131 13.8681V13.6902C51.131 13.5914 51.0796 13.5005 50.9926 13.453L50.3483 13.0854C50.1704 12.9826 49.949 13.1131 49.949 13.3186V13.7416C49.949 13.9512 49.7236 14.0816 49.5418 13.9788L48.2767 13.2514L47.0156 12.528C46.8338 12.4252 46.8338 12.1603 47.0156 12.0575L48.2767 11.3341L49.5418 10.6067C49.7236 10.5039 49.949 10.6343 49.949 10.8439V11.0534C49.949 12.1129 51.0954 12.777 52.0126 12.2473L53.4002 11.4527L54.768 10.6699C55.6892 10.1362 55.6892 8.80791 54.768 8.27817Z" fill="black"/>
              <path d="M13.3698 11.4882C13.1168 12.5675 12.1878 13.3107 10.986 13.3107C9.59836 13.3107 8.55469 12.267 8.55469 10.8873C8.55469 9.50763 9.61417 8.45605 11.0057 8.45605C12.1799 8.45605 13.097 9.19928 13.3619 10.2588H12.1403C11.9229 9.83576 11.492 9.55507 11.0136 9.55507C10.3179 9.55507 9.73672 10.1283 9.73672 10.8873C9.73672 11.6464 10.3179 12.2196 11.0136 12.2196C11.5118 12.2196 11.9427 11.9389 12.1482 11.4882H13.3698Z" fill="black"/>
              <path d="M13.9209 13.2356V6.60986H15.1029V13.2356H13.9209Z" fill="black"/>
              <path d="M16.878 11.1996C16.961 11.8954 17.4591 12.2868 18.0877 12.2868C18.5858 12.2868 18.9693 12.0535 19.1946 11.6779H20.4043C20.1236 12.6742 19.2302 13.3107 18.056 13.3107C16.6368 13.3107 15.6445 12.3144 15.6445 10.8991C15.6445 9.48387 16.6961 8.45996 18.0837 8.45996C19.4832 8.45996 20.4952 9.49177 20.4952 10.8991C20.4952 11.0019 20.4873 11.1047 20.4676 11.1996H16.878ZM19.2341 10.4643C19.1511 9.85548 18.653 9.48782 18.0719 9.48782C17.4907 9.48782 17.0124 9.84362 16.8898 10.4643H19.2341Z" fill="black"/>
              <path d="M24.7194 13.2356V12.6268C24.3715 13.0498 23.8575 13.3107 23.2369 13.3107C21.9521 13.3107 20.9756 12.2789 20.9756 10.8873C20.9756 9.50763 21.9876 8.45605 23.2645 8.45605C23.8654 8.45605 24.3715 8.71697 24.7194 9.13207V8.53907H25.8737V13.2316H24.7194V13.2356ZM24.7075 10.8873C24.7075 10.1006 24.1343 9.54321 23.4306 9.54321C22.7269 9.54321 22.1537 10.1046 22.1537 10.8873C22.1537 11.6582 22.7269 12.2315 23.4306 12.2315C24.1343 12.2315 24.7075 11.678 24.7075 10.8873Z" fill="black"/>
            </svg>
            <span>(excludes subscriptions)</span>
          </div>

          <button class="add-to-cart" @click=${() => this.addToCart()}>Add to Bag</button>
  
          <div class="bottom-copy">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.7263 6.2774L11.6558 4.82427L11.6681 3.01902C11.6692 2.85437 11.5632 2.70848 11.4062 2.65926L9.68521 2.11434L8.6358 0.645392C8.5397 0.511213 8.36802 0.455552 8.21217 0.507697L6.49947 1.07957L4.78677 0.507697C4.6309 0.455548 4.45864 0.511213 4.36314 0.645392L3.31372 2.11376L1.59277 2.65926C1.43574 2.70848 1.32969 2.85497 1.33086 3.01902L1.34316 4.82427L0.272657 6.2774C0.175391 6.40982 0.175391 6.59028 0.272657 6.72272L1.34316 8.17584L1.33086 9.98109C1.32968 10.1457 1.43574 10.2916 1.59277 10.3409L3.31372 10.8858L4.36314 12.3547C4.43521 12.4555 4.54947 12.5118 4.66842 12.5118C4.70826 12.5118 4.7481 12.5053 4.78736 12.4924L6.49946 11.9205L8.21216 12.4924C8.36803 12.5446 8.54029 12.4889 8.63579 12.3547L9.68521 10.8864L11.4062 10.3409C11.5632 10.2916 11.6692 10.1452 11.6681 9.9811L11.6558 8.17585L12.7263 6.72272C12.8235 6.5903 12.8235 6.40984 12.7263 6.2774L12.7263 6.2774ZM10.9779 7.83065C10.9298 7.89569 10.904 7.97479 10.9046 8.05565L10.9158 9.70865L9.33897 10.2079C9.26162 10.2325 9.19424 10.2811 9.14737 10.3473L8.18644 11.6926L6.61789 11.1688C6.54055 11.143 6.45735 11.143 6.38001 11.1688L4.81206 11.6932L3.85113 10.3479C3.80425 10.2817 3.73628 10.2331 3.65953 10.2084L2.08333 9.70923L2.09447 8.05623C2.09505 7.97537 2.06927 7.89627 2.02122 7.83123L1.04036 6.49998L2.02122 5.16932C2.06927 5.10428 2.09505 5.02518 2.09447 4.94432L2.08333 3.29132L3.66013 2.7921C3.73748 2.76749 3.80486 2.71886 3.85173 2.65265L4.81266 1.30733L6.38121 1.83116C6.45855 1.85694 6.54175 1.85694 6.61909 1.83116L8.18764 1.30733L9.14857 2.65265C9.19545 2.71886 9.26341 2.76749 9.34017 2.7921L10.9164 3.29132L10.9052 4.94432C10.9046 5.02518 10.9304 5.10428 10.9785 5.16932L11.9588 6.49998L10.9779 7.83065Z" fill="black"/>
                <path d="M8.3442 4.82841L5.7966 7.37601L4.65577 6.23518C4.50929 6.0887 4.27198 6.0887 4.12549 6.23518C3.979 6.38166 3.97901 6.61897 4.12549 6.76546L5.53174 8.17171C5.60498 8.24495 5.70108 8.28128 5.79717 8.28128C5.89326 8.28128 5.98876 8.24495 6.06259 8.17171L8.87509 5.35921C9.02157 5.21273 9.02157 4.97542 8.87509 4.82893C8.72802 4.68245 8.49013 4.68245 8.34423 4.82834L8.3442 4.82841Z" fill="black"/>
              </svg>
              Free UK Shipping
            </span>
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.7263 6.2774L11.6558 4.82427L11.6681 3.01902C11.6692 2.85437 11.5632 2.70848 11.4062 2.65926L9.68521 2.11434L8.6358 0.645392C8.5397 0.511213 8.36802 0.455552 8.21217 0.507697L6.49947 1.07957L4.78677 0.507697C4.6309 0.455548 4.45864 0.511213 4.36314 0.645392L3.31372 2.11376L1.59277 2.65926C1.43574 2.70848 1.32969 2.85497 1.33086 3.01902L1.34316 4.82427L0.272657 6.2774C0.175391 6.40982 0.175391 6.59028 0.272657 6.72272L1.34316 8.17584L1.33086 9.98109C1.32968 10.1457 1.43574 10.2916 1.59277 10.3409L3.31372 10.8858L4.36314 12.3547C4.43521 12.4555 4.54947 12.5118 4.66842 12.5118C4.70826 12.5118 4.7481 12.5053 4.78736 12.4924L6.49946 11.9205L8.21216 12.4924C8.36803 12.5446 8.54029 12.4889 8.63579 12.3547L9.68521 10.8864L11.4062 10.3409C11.5632 10.2916 11.6692 10.1452 11.6681 9.9811L11.6558 8.17585L12.7263 6.72272C12.8235 6.5903 12.8235 6.40984 12.7263 6.2774L12.7263 6.2774ZM10.9779 7.83065C10.9298 7.89569 10.904 7.97479 10.9046 8.05565L10.9158 9.70865L9.33897 10.2079C9.26162 10.2325 9.19424 10.2811 9.14737 10.3473L8.18644 11.6926L6.61789 11.1688C6.54055 11.143 6.45735 11.143 6.38001 11.1688L4.81206 11.6932L3.85113 10.3479C3.80425 10.2817 3.73628 10.2331 3.65953 10.2084L2.08333 9.70923L2.09447 8.05623C2.09505 7.97537 2.06927 7.89627 2.02122 7.83123L1.04036 6.49998L2.02122 5.16932C2.06927 5.10428 2.09505 5.02518 2.09447 4.94432L2.08333 3.29132L3.66013 2.7921C3.73748 2.76749 3.80486 2.71886 3.85173 2.65265L4.81266 1.30733L6.38121 1.83116C6.45855 1.85694 6.54175 1.85694 6.61909 1.83116L8.18764 1.30733L9.14857 2.65265C9.19545 2.71886 9.26341 2.76749 9.34017 2.7921L10.9164 3.29132L10.9052 4.94432C10.9046 5.02518 10.9304 5.10428 10.9785 5.16932L11.9588 6.49998L10.9779 7.83065Z" fill="black"/>
                <path d="M8.3442 4.82841L5.7966 7.37601L4.65577 6.23518C4.50929 6.0887 4.27198 6.0887 4.12549 6.23518C3.979 6.38166 3.97901 6.61897 4.12549 6.76546L5.53174 8.17171C5.60498 8.24495 5.70108 8.28128 5.79717 8.28128C5.89326 8.28128 5.98876 8.24495 6.06259 8.17171L8.87509 5.35921C9.02157 5.21273 9.02157 4.97542 8.87509 4.82893C8.72802 4.68245 8.49013 4.68245 8.34423 4.82834L8.3442 4.82841Z" fill="black"/>
              </svg>
              Moneyback guarantee
            </span>
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.7263 6.2774L11.6558 4.82427L11.6681 3.01902C11.6692 2.85437 11.5632 2.70848 11.4062 2.65926L9.68521 2.11434L8.6358 0.645392C8.5397 0.511213 8.36802 0.455552 8.21217 0.507697L6.49947 1.07957L4.78677 0.507697C4.6309 0.455548 4.45864 0.511213 4.36314 0.645392L3.31372 2.11376L1.59277 2.65926C1.43574 2.70848 1.32969 2.85497 1.33086 3.01902L1.34316 4.82427L0.272657 6.2774C0.175391 6.40982 0.175391 6.59028 0.272657 6.72272L1.34316 8.17584L1.33086 9.98109C1.32968 10.1457 1.43574 10.2916 1.59277 10.3409L3.31372 10.8858L4.36314 12.3547C4.43521 12.4555 4.54947 12.5118 4.66842 12.5118C4.70826 12.5118 4.7481 12.5053 4.78736 12.4924L6.49946 11.9205L8.21216 12.4924C8.36803 12.5446 8.54029 12.4889 8.63579 12.3547L9.68521 10.8864L11.4062 10.3409C11.5632 10.2916 11.6692 10.1452 11.6681 9.9811L11.6558 8.17585L12.7263 6.72272C12.8235 6.5903 12.8235 6.40984 12.7263 6.2774L12.7263 6.2774ZM10.9779 7.83065C10.9298 7.89569 10.904 7.97479 10.9046 8.05565L10.9158 9.70865L9.33897 10.2079C9.26162 10.2325 9.19424 10.2811 9.14737 10.3473L8.18644 11.6926L6.61789 11.1688C6.54055 11.143 6.45735 11.143 6.38001 11.1688L4.81206 11.6932L3.85113 10.3479C3.80425 10.2817 3.73628 10.2331 3.65953 10.2084L2.08333 9.70923L2.09447 8.05623C2.09505 7.97537 2.06927 7.89627 2.02122 7.83123L1.04036 6.49998L2.02122 5.16932C2.06927 5.10428 2.09505 5.02518 2.09447 4.94432L2.08333 3.29132L3.66013 2.7921C3.73748 2.76749 3.80486 2.71886 3.85173 2.65265L4.81266 1.30733L6.38121 1.83116C6.45855 1.85694 6.54175 1.85694 6.61909 1.83116L8.18764 1.30733L9.14857 2.65265C9.19545 2.71886 9.26341 2.76749 9.34017 2.7921L10.9164 3.29132L10.9052 4.94432C10.9046 5.02518 10.9304 5.10428 10.9785 5.16932L11.9588 6.49998L10.9779 7.83065Z" fill="black"/>
                <path d="M8.3442 4.82841L5.7966 7.37601L4.65577 6.23518C4.50929 6.0887 4.27198 6.0887 4.12549 6.23518C3.979 6.38166 3.97901 6.61897 4.12549 6.76546L5.53174 8.17171C5.60498 8.24495 5.70108 8.28128 5.79717 8.28128C5.89326 8.28128 5.98876 8.24495 6.06259 8.17171L8.87509 5.35921C9.02157 5.21273 9.02157 4.97542 8.87509 4.82893C8.72802 4.68245 8.49013 4.68245 8.34423 4.82834L8.3442 4.82841Z" fill="black"/>
              </svg>
              Secure Checkout
            </span>
          </div>
        </div>

      </fieldset>`
  }

  updated = (changed) => {
    if(changed.has('product') && this.product) {
      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort(function(a,b){
          if (parseInt(a.name.replace(/\D/g, "")) < parseInt(b.name.replace(/\D/g, ""))) return -1;
          if (parseInt(a.name.replace(/\D/g, "")) > parseInt(b.name.replace(/\D/g, ""))) return 1;
          if (parseInt(a.name.replace(/\D/g, "")) == parseInt(b.name.replace(/\D/g, ""))) return 0;
        })
      });

    }

    if(changed.has('selectedVariant') && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach((group => {
          if (this.defaultFrequency) {
            let selling_plan = group.selling_plans.find(x => x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()));
            if (selling_plan) group.selected_selling_plan = selling_plan;
            else group.selected_selling_plan = group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
       }));

        if (this.startSubscription == true || this.product.requires_selling_plan == true || this.purchaseOption == 'subscription') {
          //find a matching selling plan, or choose first available

          if (this.selectedSellingPlan == null || this.selectedSellingPlan == undefined) {

            let sellingPlanGroup = this.availableSellingPlanGroups.find(x => x.options[0].name.includes(this.selectedVariant.id));

            this.selectSellingPlanGroup(sellingPlanGroup);
          }

          let sellingPlanName = this.selectedSellingPlan.name;

          let sellingPlanGroup = this.availableSellingPlanGroups.find(x => x.selling_plans.find(y => y.name == sellingPlanName));
          let sellingPlan = sellingPlanGroup.selling_plans.find(y => y.name == sellingPlanName);
          if (sellingPlanName == sellingPlan.name) {
            this.selectedSellingPlanGroup = sellingPlanGroup;
            this.selectedSellingPlan = sellingPlan;
          } else {
          this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
          this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];
          }

        } else {
          this.selectedSellingPlan, this.selectedSellingPlanGroup = null
        }
      }

      //update the form that was passed, if any
      this.updateForm();

    }

    if(changed.has('selectedSellingPlan')) {
      //update price of price elements if applicable
      document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });

      //update display of external content elements
      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true, 
        composed: true, 
        detail: {
          sellingPlan: this.selectedSellingPlan,
          key: this.key
        }
      });

      this.dispatchEvent(event);

      //update the form that was passed, if any
      this.updateForm();
      this.updateExternalPrice();

    }

    if(changed.has('formId')) {
      //update the form that was passed, if any
      this.updateForm();
    }

  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error = (...args) =>  {
    args.unshift('%c [skio]', 'color: #ff0000');
    console.error.apply(console, args);
  }

  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan);
    })
    document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan) + ' ' + this.currency;
    })

  }
  
  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    if (group) this.purchaseOption = 'subscription'
    else this.purchaseOption = 'onetime'

    //update the form that was passed, if any
    this.updateForm();
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(element, group) {
    let selling_plan = group.selling_plans.find(x => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
    }
    else this.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {

    if (!selling_plan)
      return { percent: '0%', amount: 0 }

    if (selling_plan.name.includes('prepaid')) {

      let option = selling_plan.options[0]['value'];

      var numberPattern = /\d+/g;
      let result = parseInt(option.match( numberPattern ).join(''));

      const price_adjustment = selling_plan.price_adjustments[0]
      const discount = { percent: '0%', amount: 0 }
      const price = this.selectedVariant.price * result;
      
      switch (price_adjustment.value_type) {
        case 'percentage':
          discount.percent = `${price_adjustment.value}%`
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          )
          break
        case 'fixed_amount':
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`
          discount.amount = price - price_adjustment.value
          break
        case 'price':
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) /
              price) *
              100.0
          )}%`
          discount.amount = price - price_adjustment.value
          break
      }
      
      return discount

    } else {

      const price_adjustment = selling_plan.price_adjustments[0]
      const discount = { percent: '0%', amount: 0 }
      const price = this.selectedVariant.price;
      
      switch (price_adjustment.value_type) {
        case 'percentage':
          discount.percent = `${price_adjustment.value}%`
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          )
          break
        case 'fixed_amount':
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`
          discount.amount = price_adjustment.value
          break
        case 'price':
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) /
              price) *
              100.0
          )}%`
          discount.amount = price - price_adjustment.value
          break
      }
      
      return discount

    }
    
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {

    if (selling_plan.name.includes('prepaid')) {

      let option = selling_plan.options[0]['value'];
      var numberPattern = /\d+/g;
      let result = parseInt(option.match( numberPattern ).join(''));

      return formatted
        ? this.money( (this.selectedVariant.price * result) - this.discount(selling_plan).amount)
        :  (this.selectedVariant.price * result) - this.discount(selling_plan).amount

    } else {

      return formatted
        ? this.money( this.selectedVariant.price - this.discount(selling_plan).amount)
        :  this.selectedVariant.price - this.discount(selling_plan).amount

    }

    
  }

  // If a formId was passed, appends the necessary <input> elements to the form
  updateForm() {
    if (this.formId) {
      let form = document.querySelector(`#${this.formId}`);

      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) {
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          selling_plan_input = document.createElement('input');
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(selling_plan_input);
        }

        let discount_input = form.querySelector('[name="properties[Discount]"]');
        if (discount_input) {
          discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          discount_input = document.createElement('input');
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(discount_input);
        }

      } else {
        console.log(`Skio error: form ID is ${ this.formId }, but no form with that ID was found.`);
      }
    }
  }

  // Optional functions keep if necessary 

  /**
   *   
   * 
   */
  
  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity = 1) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && { selling_plan: this.selectedSellingPlan?.id })
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then((response) => response.json())
    .then((response) => {
      this.log("SKIO added item to cart: ", response);
      //dispatch CustomEvent to tell document that an item was added to cart
      const event = new CustomEvent(`skio::added-to-cart`, {
        bubbles: true, 
        composed: true, 
        detail: {
          response,
          key: this.key
        }
      });

      this.dispatchEvent(event);

      window.location.href = '/cart';
    })
    .catch((error) => {
      this.error(`SKIO ${ this.key } error adding item to cart: `, error);
    });
  } 

  fetchProduct = (handle) => {
    return fetch(`/products/${ handle }.js`)
    .then((response) => response.json())
    .then((product) => {
      this.product = product;
      this.selectedVariant = product.variants[0];

      return product;
    });
  }
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent);
